import Moment from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { TranslationFuncProp } from '../../../common/types/prop-types/common';
import imgCardSmallBMW from '../../assets/images/bmw-card-small.png';
import imgCardSmallMINI from '../../assets/images/mini-card-small.png';
import { config } from '../../common';
import css from './Cards.scss';

interface CardTemplateProps {
    state: string;
    type: string | undefined | null;
    number: string | undefined | null | number;
    dealer: string | undefined | null;
    licensePlate: string | number | string[] | undefined | null;
    vin: string | number | string[] | undefined | null;
    validDate: Date | undefined | null;
}

const BMWCardTemplate: React.FC<CardTemplateProps & TranslationFuncProp> = (props) => {
    return (
        <div className={css.card}>
            <figure className={'orbit-figure'}>
                <img className={'orbit-image'} src={imgCardSmallBMW} alt="BMW Service" />
                <figcaption className={'orbit-caption'}>
                    <h5>{props.type}</h5>
                    <p>{props.state}</p>
                    <p>
                        {props.t('cards:card.dealer')} <span>{props.dealer}</span>
                    </p>
                    <p>
                        {props.t('cards:card.number')} <span>{props.number}</span>
                    </p>
                    <p>
                        {props.t('cards:card.validDate')} <span>{props.validDate ? Moment(props.validDate).format('DD/MM/YYYY') : '–'}</span>
                    </p>
                    <p>
                        {props.t('cards:card.plate')} <span>{props.licensePlate}</span>
                    </p>
                    <p>
                        {props.t('cards:card.vin')} <span>{props.vin}</span>
                    </p>
                </figcaption>
            </figure>
        </div>
    );
};

const MINICardTemplate: React.FC<CardTemplateProps & TranslationFuncProp> = (props) => {
    return (
        <div className={css.card}>
            <figure className={'orbit-figure'}>
                <img className={'orbit-image'} src={imgCardSmallMINI} alt="BMW Service" />
                <figcaption className={'orbit-caption'}>
                    <h5>{props.type}</h5>
                    <p>{props.state}</p>
                    <p>
                        {props.t('cards:card.dealer')} <span>{props.dealer}</span>
                    </p>
                    <p>
                        {props.t('cards:card.number')} <span>{props.number}</span>
                    </p>
                    <p>
                        {props.t('cards:card.validDate')} <span>{props.validDate ? Moment(props.validDate).format('DD/MM/YYYY') : '–'}</span>
                    </p>
                    <p>
                        {props.t('cards:card.plate')} <span>{props.licensePlate}</span>
                    </p>
                    <p>
                        {props.t('cards:card.vin')} <span>{props.vin}</span>
                    </p>
                </figcaption>
            </figure>
        </div>
    );
};

const CardTemplate: React.FC<CardTemplateProps> = (props) => {
    const { t } = useTranslation();

    switch (config.BrandEnv) {
        case 'BMW':
            return <BMWCardTemplate {...props} t={t} />;
        case 'MINI':
            return <MINICardTemplate {...props} t={t} />;
        default:
            return <BMWCardTemplate {...props} t={t} />;
    }
};

export default CardTemplate;
